// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Say to God, &#145;How awesome are your deeds!&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Because of your great strength<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;your enemies shall bow before you.<br> </p> </div></div>";
// Exports
module.exports = code;